import { useEffect, useState } from 'react'
import './NavigationNotice.scss'
import NavigationIcon from '../icons/NavigationIcon'

export function NavigationNotice(props: {isDragging?:boolean}) {

    const [isHidden, setIsHidden] = useState("");

    useEffect(()=> {
        if(props.isDragging){
            setIsHidden("gno-notice-hide");
        }
        else {
            setIsHidden("");
        }

    },[props.isDragging, isHidden])

    return (<div className={`gno-navigation-notice-container ${isHidden}`}>
        <div className ="gno-navigation-notice-icon"> <NavigationIcon /> </div>
        <div className="gno-hide-shadow"></div>
        <div className="gno-navigatione-notice-text">
            <p>Karte navigierbar</p>
        </div>
    </div>
    )
}
